module.exports = __webpack_public_path__ + "static/media/top.7b9da5bb.png";